import React, { useState, useEffect } from "react";
import { useCallback } from "react";
import RoomHeader from "../../../components/AppointmentRoom/RoomHeader";
import RoomFooter from "../../../components/AppointmentRoom/RoomFooter";
import RoomBody from "../../../components/AppointmentRoom/RoomBody";
import CircularProgress from "../../../components/CircularProgress";
import { useUserState } from "../../../providers/UserProvider";
import * as HTTPServices from "../../../api/HTTPServices";
// import { useActiveRoomState } from "../../../providers/ActiveRoomProvider";
/* eslint-disable no-unused-vars */
import Pusher from "pusher-js";
import Echo from "laravel-echo";
// import _ from "lodash";
import RequestVideoCallModal from "../../../components/RequestVideoCall";
import ModalComponent from "../../../components/ModalComponent";

import * as Toast from "../../../lib/toast";
import classes from "./index.module.scss";

function Index(props) {
  const user = useUserState();
  let clientId = user.user_login && user.user_login.client_id;
  const [loading, setLoading] = useState(false);
  const [chats, setChats] = useState("");
  const [audienceUser, setAudienceUser] = useState("");
  const [patientVideoCallRequestModal, setPatientVideoCallRequestModal] =
    useState(false);
  const [loadingPatientVideoCallRequest, setLoadingPatientVideoCallRequest] =
    useState(false);
  const [loadingVideoCall, setLoadingVideoCall] = useState(false);
  const [showVoiceCallModal, setShowVoiceCallModal] = useState(false);
  const [loadingVoiceCall, setLoadingVoiceCall] = useState(false);
  let audienceId = new URLSearchParams(props.location.search).get("audience");
  let visitToken = new URLSearchParams(props.location.search).get("token");
  // const activeRoom = useActiveRoomState();

  useEffect(() => {
    fetchMessages();
    echoJoin();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.search]);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chats]);
  const newEcho = () => {
    const echo = new Echo({
      broadcaster: "pusher",
      key: "7890123456",

      wsHost: "push.sbm24.com",
      wssPort: 6001,
      wsPort: 6001,
      disableStats: true,
      forceTLS: true,
      //enabledTransports: ['wss'],
      authEndpoint: "https://sandbox.sbm24.net/broadcasting/auth",
      auth: {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token_echo")}`,
          Accept: "application/json",
        },
      },
    });
    return echo;
  };
  let ChatCallChannel = newEcho().join(`chat.${visitToken}`);

  const echoJoin = () => {
    ChatCallChannel.here((users) => {
      let findAudienceUser = users.find((user) => user.id !== clientId);

      setAudienceUser(findAudienceUser);

      // this.props.SeenChat();

      setTimeout(() => {
        if (audienceUser) {
          // let el = document.getElementById("member_" + audienceUser.id);
          // if (el) {
          //   el.classList.add("online", "public_online");
          // }
        }
      }, 500);
    })
      .joining((user) => {
        // console.log(JSON.stringify(user), " Join the Channel");
        setTimeout(() => {
          let el = document.getElementById("member_" + user.id);
          if (el) {
            el.classList.add("online", "public_online");
          }
        }, 500);

        // setTimeout(() => {
        //   var NewChat = [];
        //   let LiveObject = this;
        //   _.map(LiveObject.state.chats, (chat) => {
        //     if (
        //       chat.user_id == this.props.UserLogin.client_id &&
        //       user.id == chat.audience &&
        //       chat.seen == false
        //     ) {
        //       chat.seen = true;
        //     }
        //     NewChat.push(chat);
        //   });
        //   LiveObject.setState({
        //     chats: NewChat,
        //   });
        // }, 1000);
      })
      .leaving((user) => {
        // console.log(user.id + " Leave the Channel");
        // setTimeout(() => {
        //   let el = document.getElementById("member_" + user.id);
        //   if (el) {
        //     el.classList.remove("online");
        //   }
        // }, 500);
      })
      .listen("MessageSent", (e) => {
        if (e) {
          if (!Array.isArray(e.data)) {
            if (parseInt(e.data.user_id) !== parseInt(clientId)) {
              // LiveObject.setState({
              //   chats: [...LiveObject.state.chats, e.data],
              // });

              // let a = [];
              // let newChat = e.data;
              // a.push(newChat);
              // let prevChat = chats;
              // let concatWithChat = prevChat.concat(newChat);
              // console.log(`concatWithChat in socket`, concatWithChat);
              // console.log(`e.data`, e.data);
              setTimeout(() => {
                // setChats(concatWithChat);
                // setChats([...chats, e.data]);
                let updatedChats = [...chats, e.data];
                setChats((prevChats) => [...prevChats, ...updatedChats]);
              }, 100);

              if (e.data.id) {
                // LiveObject.SeenMessage(e.data.id);
              }
            }
          } else {
            e.data.forEach((dossier) => {
              setChats((prevChats) => [...prevChats, ...dossier]);

              if (dossier.id) {
                // LiveObject.SeenMessage(dossier.id);
              }
            });
            // e.data.map((dossier) => {
            //   // LiveObject.setState({
            //   //   chats: [...LiveObject.state.chats, dossier],
            //   // });
            //   setChats([...chats, dossier]);

            //   if (document.getElementById("chat_list_end"))
            //     document.getElementById("chat_list_end").scrollIntoView();

            //   if (dossier.id) {
            //     // LiveObject.SeenMessage(dossier.id);
            //   }
            // });
          }
        }
      });
    // .listen("SeenMessage", (e) => {
    //   //new seen message
    //   var LiveObject = this;

    //   if (parseInt(e.message.user_id) == parseInt(this.user.id)) {
    //     // LiveObject.setState({
    //     //   chats: [...LiveObject.state.chats, e.data],
    //     // });

    //     if (document.getElementById("chat_list_end"))
    //       document.getElementById("chat_list_end").scrollIntoView();

    //     if (e.message.seen_audience === 1) {
    //       setTimeout(() => {
    //         var NewChat = [];
    //         _.map(LiveObject.state.chats, (chat) => {
    //           if (e.message.id === chat.key) {
    //             chat.seen = true;
    //           }
    //           NewChat.push(chat);
    //         });
    //         LiveObject.setState({
    //           chats: NewChat,
    //         });
    //       }, 1000);
    //     }
    //   }
    // })
    // .listenForWhisper("typing", (e) => {
    //   this.setState({ isTyping: e.typing });
    // });
  };

  const fetchMessages = useCallback(() => {
    setLoading(true);

    const RequestService = HTTPServices.getMethod(
      "chat",
      "audience=" + audienceId + "&token=" + visitToken,
      "true"
    );

    RequestService.then(function (response) {
      if (response) {
        let concatMessages;
        concatMessages = concatMessages = systemMessages.concat(response);
        setChats(concatMessages);
        setLoading(false);
      }
    }).catch(function (error) {
      console.log(`error`, error);
      setLoading(false);
    });
  }, [audienceId, visitToken]);

  const sendMessage = (message) => {
    if (message) {
      const params = new URLSearchParams();
      params.append("audience", audienceId);
      params.append("message", message);
      params.append("room_token", visitToken);

      const RequestService = HTTPServices.postMethod("chat", params, "true");
      RequestService.then(function (response) {
        if (response) {
          addMessageToList(response.message);

          if (document.getElementById("chat_list_end"))
            document.getElementById("chat_list_end").scrollIntoView();
        }
      });
    }
  };

  const addMessageToList = (message) => {
    setChats([...chats, message]);

    setTimeout(function () {
      if (document.getElementById("chat_list_end"))
        document.getElementById("chat_list_end").scrollIntoView();
    }, 100);
  };

  const handleVideoCallRequest = () => {
    setLoadingPatientVideoCallRequest(true);
    const params = new URLSearchParams();
    params.append("doctor", audienceId);
    params.append("room_token", visitToken);

    const RequestService = HTTPServices.postMethod(
      "video_call_request",
      params,
      "true"
    );
    RequestService.then(function (response) {
      Toast.SuccessData("request video call has been sent to docter");
      setPatientVideoCallRequestModal(false);
      setLoadingPatientVideoCallRequest(false);
    }).catch(function (error) {
      Toast.ErrorData("cant stablish connection");
      setLoadingPatientVideoCallRequest(false);
    });
  };

  const videoCallHandler = () => {
    setLoadingVideoCall(true);
    const params = new URLSearchParams();
    params.append("token", visitToken);

    const RequestService = HTTPServices.postMethod(
      "binjoo_video_call_request",
      params,
      "true"
    );
    RequestService.then(function (response) {
      if (response) {
        Toast.SuccessData("video call is stablishing");
        setLoadingVideoCall(false);
        let drLink = response.doctor;
        let isSafari = window.safari !== undefined;
        if (isSafari) {
          setTimeout(() => {
            window.location.href = drLink;
          }, 100);
        } else {
          window.open(drLink, "_blank");
        }
      }
    });
  };
  const voiceCallHandler = () => {
    setLoadingVoiceCall(true);
    Toast.SuccessData("voice call is stablishing");
    const params = new URLSearchParams();
    let token = visitToken;

    const RequestService = HTTPServices.postMethod(
      "voice_create",
      params,
      "true",
      "post",
      "false",
      token,
      false
    );
    RequestService.then(function (response) {
      if (response) {
        setLoadingVoiceCall(false);
        setShowVoiceCallModal(false);
        Toast.SuccessData("secure call will be made in a few moments");
      }
    }).catch(function (error) {
      setLoadingVoiceCall(false);
    });
  };

  return (
    <div
      className={classes.maincontainer}
      // className={
      //   activeRoom
      //     ? `classes.maincontainer showRoomInResponsiveMode`
      //     : classes.maincontainer
      // }
    >
      {loading ? (
        <div className={classes.CircularProgress}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <RoomHeader
            audienceId={audienceId}
            visitToken={visitToken}
            patientVideoCallRequestModal={() => {
              setPatientVideoCallRequestModal(true);
            }}
            onVideoCall={videoCallHandler}
            openVoiceCall={() => setShowVoiceCallModal(true)}
            loadingVideoCall={loadingVideoCall}
            loadingVoiceCall={loadingVoiceCall}
          />
          <div className={classes.roomBody}>
            <RoomBody chats={chats} />
          </div>
          <RoomFooter
            sendMessage={sendMessage}
            addMessageToList={addMessageToList}
            visitToken={visitToken}
            audienceId={audienceId}
          />
        </>
      )}
      <RequestVideoCallModal
        handleOpenVideoCallRequest={patientVideoCallRequestModal}
        handleCloseVideoCallRequest={() => {
          setPatientVideoCallRequestModal(false);
        }}
        handleVideoCallRequest={handleVideoCallRequest}
        loadingRequest={loadingPatientVideoCallRequest}
      />
      <ModalComponent
        open={showVoiceCallModal}
        handleClose={() => setShowVoiceCallModal(false)}
        closeBtn={true}
        confirmBtn={true}
        handleOk={voiceCallHandler}
        loadingRequest={loadingVoiceCall}
        title="private call"
      >
        Secure call time is 10 minutes and you can use this feature twice per
        visit. If the duration of your visit is long, you can use the video
        calling options (with the ability to activate or deactivate your device
        camera)
      </ModalComponent>
    </div>
  );
}

export default Index;

let systemMessages = [
  {
    message: (
      <>
        <span>کاربر گرامی سلام و آرزوی سلامتی،</span>
        <br />
        <span>شما در اتاق مشاوره پزشک خود هستید. خواهشمند است :</span>
        <br />
        <span>
          - دلیل مشاوره با پزشک را یا تایپ نموده و یا بصورت پیام صوتی و ویدیویی
          ( از قسمت ارسال مستندات ) برای پزشک ارسال نمایید.
        </span>
        <br />
        <span>
          - از آخرین آزمایش و مدارک پزشکی خود عکس بگیرید و با کلیک بر روی{" "}
          <b>ارسال مدارک </b>
          ارسال نمایید.
        </span>
        <br />
        <span>
          - اسامی داروهایی که مصرف می کنید در قسمت چت وارد کنید و یا عکس آن را
          با کلیک بر روی <b>ارسال مدارک</b> ارسال نمایید.
        </span>

        <br />
        <span>
          مدت انتظار شما از زمان موعد ویزیت تا حضور پزشک نهایتاً ۳ ساعت میباشد.
        </span>
      </>
    ),
    type: "systemMessages",
  },
];
